import { css } from 'aphrodite';
import * as React from 'react';
import { styles } from './styles';

export const EventsNotFound: React.FC = () => {
	return (
		<div className={css(styles.container)}>
			<div className={css(styles.content)}>
				<h1 className={css(styles.title)}>No Upcoming Events</h1>
				<p className={css(styles.message)}>There are no upcoming events at this time. Please check back soon!</p>
			</div>
		</div>
	);
};
